import React, { useRef, useState } from "react";
import { Button, Overlay, Popover } from "react-bootstrap";

const PopoverTooltip = ({header, message, target, show, reference}) => {
  
    return (
      <>
        <Overlay
          show={show}
          target={target}
          placement="bottom"
          container={reference.current}
          containerPadding={20}
        >
          <Popover id="popover-contained">
            {header && <Popover.Title as="h3">{header}</Popover.Title>}
            <Popover.Content>
              {message}
            </Popover.Content>
          </Popover>
        </Overlay>
      </>
    );
}
export {
    PopoverTooltip
}